<div class="section-title" [ngClass]="'size-' + size">
    <div class="section-title__accent"></div>
    <div class="section-title__content">
        <div class="section-title__row">
            <mat-icon *ngIf="icon" class="section-title__icon">{{ icon }}</mat-icon>
            <h3 class="section-title__text">{{ title }}</h3>
            <div class="section-title__actions">
                <ng-content></ng-content>
            </div>
        </div>
        <p *ngIf="subtitle" class="section-title__subtitle">{{ subtitle }}</p>
    </div>
</div>
